var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "update-popup-con" }, [
    _c(
      "div",
      { staticClass: "table-con" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm.isAdmin
          ? _c("div", [
              _c(
                "div",
                { staticClass: "sk-switch-con" },
                [
                  _c(
                    "CSwitch",
                    {
                      attrs: { color: "#4caf50" },
                      model: {
                        value: _vm.inputVisible,
                        callback: function($$v) {
                          _vm.inputVisible = $$v
                        },
                        expression: "inputVisible"
                      }
                    },
                    [_vm._v("Is a PO required?")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.inputVisible
                ? _c("div", { staticClass: "sk-input-con" }, [
                    _c("label", { attrs: { for: "input" } }, [_vm._v("PO #")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData,
                          expression: "inputData"
                        }
                      ],
                      staticClass: "input",
                      attrs: { id: "input", type: "text" },
                      domProps: { value: _vm.inputData },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.inputData = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "select-con" },
                [
                  _c("h3", [_vm._v("Select Ship-TO for Order:")]),
                  _vm._v(" "),
                  _c("model-select", {
                    attrs: {
                      options: _vm.options,
                      placeholder: "Please select allocation address"
                    },
                    model: {
                      value: _vm.selectValue,
                      callback: function($$v) {
                        _vm.selectValue = $$v
                      },
                      expression: "selectValue"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("vue-good-table", {
          attrs: {
            columns: _vm.columns,
            rows: _vm.rows,
            "sort-options": {
              enabled: false
            }
          },
          scopedSlots: _vm._u([
            {
              key: "table-row",
              fn: function(props) {
                return [
                  props.column.field === "qty"
                    ? _c("span", [
                        _c("input", {
                          staticClass: "input-number",
                          attrs: {
                            type: "number",
                            step: "1",
                            min: "0",
                            max: props.row.available
                          },
                          domProps: { value: _vm.qty["" + props.row.id] },
                          on: {
                            change: function(e) {
                              return _vm.someHandler(
                                props.row.id,
                                e.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n      " +
                            _vm._s(props.formattedRow[props.column.field]) +
                            "\n    "
                        )
                      ])
                ]
              }
            }
          ])
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-con" },
          [
            _c("CButton", {
              attrs: { color: "green", text: "Save" },
              on: { click: _vm.onSaveClick }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml20" },
              [
                _c("CButton", {
                  attrs: { color: "red", text: "Cancel" },
                  on: { click: _vm.onCancel }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-header" }, [
      _c("h3", [_vm._v("UPDATE ORDER ALLOCATIONS")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }